import FlowStart from "Components/Device/Flow/FlowStart";
import SimpleLoader from "Components/Shared/SimpleLoader";
import { useDevice } from "Hooks/Endpoints";
import { APIDeviceProps } from "Providers/types";
import React from "react";
import { Container } from "semantic-ui-react";

const FlowDiagramHolder = () => {
  const { activeFlow, submitting }: APIDeviceProps = useDevice();
  return (
    <Container fluid style={{ minHeight: "160px" }}>
      <SimpleLoader loading={submitting}>
        {activeFlow && <FlowStart />}
      </SimpleLoader>
    </Container>
  );
};

export default FlowDiagramHolder;
